import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getSharedMap } from '../services/api';
import './ShareMap.css';

function ShareMap() {
  const { shareId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadSharedMap = async () => {
      try {
        setLoading(true);
        setError(null);

        const share = await getSharedMap(shareId);

        // Redirect to appropriate mapper with pre-loaded config
        if (share.sourceType === 'sheet') {
          // For Google Sheets, navigate to sheet mapper with query params
          const params = new URLSearchParams({
            url: share.sourceUrl,
            tab: share.tabName || '',
            mapName: share.mapName || '',
            config: JSON.stringify(share.config)
          });
          navigate(`/sheet-mapper?${params.toString()}`);
        } else if (share.sourceType === 'quickbase') {
          // For QuickBase, navigate to quickbase mapper with query params
          const params = new URLSearchParams({
            url: share.sourceUrl,
            mapName: share.mapName || '',
            config: JSON.stringify(share.config)
          });
          navigate(`/quickbase-mapper?${params.toString()}`);
        }
      } catch (err) {
        console.error('Failed to load shared map:', err);
        setError(err.message || 'Failed to load shared map');
        setLoading(false);
      }
    };

    if (shareId) {
      loadSharedMap();
    }
  }, [shareId, navigate]);

  return (
    <div className="share-map-page">
      {loading && (
        <div className="share-loading">
          <div className="spinner"></div>
          <p>Loading shared map...</p>
        </div>
      )}

      {error && (
        <div className="share-error">
          <h2>❌ Unable to Load Map</h2>
          <p>{error}</p>
          <button onClick={() => navigate('/')} className="btn-home">
            Go to Home
          </button>
        </div>
      )}
    </div>
  );
}

export default ShareMap;
